import managementSlice from './managementSlice';

export { default as managementOp } from './operations';

export default managementSlice;
